import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";
import { StandardParagraphTableHeader, StandardParagraphTableRow } from "./components";
import useStandardParagraphsTable from "./hooks/useStandardParagraphsTable";

const StandardParagraphManagementTable = ({ showCreateModal }) => {

    const {
        clear,
        data,
        error,
        isClearing,
        isRowLoaded,
        loadMore,
        currentSort,
        sortTable,
        totalCount,
        onNameClick,
        publishParagraph,
        deleteParagraph
    } = useStandardParagraphsTable();

    return <VirtualTable
        enableScrollTracking
        row={(props) => <StandardParagraphTableRow onNameClick={onNameClick} onPublish={publishParagraph} onDelete={deleteParagraph} {...props} />}
        header={<StandardParagraphTableHeader currentSort={currentSort} sortTable={sortTable} showCreateModal={showCreateModal} />}
        footer={!isClearing && (
            <TableRecordCountDisplayFooter
                spanLeft={4}
                spanRight={1}
                totalCount={totalCount}
                reload={clear}
            />
        )}
        error={error}
        // isLoading={isClearing}
        isItemLoaded={isRowLoaded}
        loadMoreItems={loadMore}
        itemSize={60}
        itemCount={totalCount}
        itemData={data}
    />;
}

export default StandardParagraphManagementTable;